var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        size: "lg",
        "header-bg-variant": "success",
        "header-text-variant": "white",
        "hide-header-close": "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        scrollable: ""
      },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function() {
            return [_vm._v("\n    We found an updated property response\n  ")]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-button",
                { attrs: { variant: "danger" }, on: { click: _vm.onKeep } },
                [_vm._v("\n      Keep\n    ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                { attrs: { variant: "success" }, on: { click: _vm.onUpdate } },
                [_vm._v("\n      Update\n    ")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v("\n      The project owner for "),
          _c("strong", [_vm._v(_vm._s(_vm.projectName))]),
          _vm._v(
            " has linked some of the RFI\n      project questions to your property form. Keeping your property form in sync produces\n      detailed PDF property brochure reports for you and the project owner, and helps LOIS\n      users keep their property data updated.\n    "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      The response below differs from the value currently on your property form. Please perform the following actions to update your property form accordingly:\n    "
          )
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _vm._v("Click "),
            _c("strong", [_vm._v("Update")]),
            _vm._v(
              " to replace the property form response with your RFI response"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Click "),
            _c("strong", [_vm._v("Keep")]),
            _vm._v(" to keep the property form response on file as-is")
          ])
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "table table-bordered table-sm mt-3" }, [
          _c("thead", { staticClass: "thead-light" }, [
            _c("tr", [
              _c("th", [_vm._v("Question")]),
              _vm._v(" "),
              _c("th", [_vm._v("Property Response")]),
              _vm._v(" "),
              _c("th", [_vm._v("RFI Response")])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.conflicts, function(row) {
              return _c("tr", { key: row.questionId }, [
                _c("td", [_vm._v(_vm._s(row.questionText))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(row.loisDisplay))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(row.rfiDisplay))])
              ])
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }